import { render, staticRenderFns } from "./AggregateType.vue?vue&type=template&id=1761f55c&scoped=true"
import script from "./AggregateType.vue?vue&type=script&lang=js"
export * from "./AggregateType.vue?vue&type=script&lang=js"
import style0 from "./AggregateType.vue?vue&type=style&index=0&id=1761f55c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1761f55c",
  null
  
)

export default component.exports